/* Utilitiy functions that use 'this' keyword are to be placed here */
import { TestseriesDialogComponent } from '@app-shared/components/testseries-dialog/testseries-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from '@app-environments/environment';
import { AdmissionNumberLoginComponent } from '@app-shared/components/admission-number-login/admission-number-login.component';
import { LogindialogComponent } from '@app-shared/components/logindialog/logindialog.component';
import { apisDataCacheKeys, profileSuccess, timeBoundTypes } from '@app-constants/app.constants';
import { TestRegistrationConfirmDialogComponent } from '@app-shared/components/test-registration-confirm-dialog/test-registration-confirm-dialog.component';
import * as moment from 'moment';
import { ConfirmationPopupComponent } from '@app-modules/feature/myprofile/components/dialogs/confirmation-popup/confirmation-popup.component';
import { ClassService } from 'src/app/core/services/class.service';
import { clearLocalStorage } from 'src/app/helpers/functions';

export function openILITESignUpDialog(numberAndIsd: any, hiddenFields?: any): void {
  this.openTSDialog({
    message: 'One more step and you are all set',
      source: 'ILITE',
      phone: numberAndIsd?.number,
      countryCode: numberAndIsd?.dialCode,
      hiddenFields: hiddenFields || {hallticket: true},
      needPayment: true, 
      ILITE: true
  })
}

export function openTSDialog(params: any = {}){
  let {message, source, isJEE, phone, hiddenFields, needPayment, panelClass} = params;
  if(!Array.isArray(panelClass)) {
    panelClass = [panelClass]
  }
  panelClass = [...panelClass, 'neet-live-class', 'IL_marketing_register_dialog']
  const config: MatDialogConfig = {
    width: '487px',
    maxHeight: '96vh',
    height: params.ILITE ? '96vh': 'auto',
    id: 'neet-live-class',
    panelClass: panelClass,
    data: {
      ...params,
      countryCode: '+91',
    }
  };
  return (this.dialog.open(TestseriesDialogComponent, config));
}

export function openLoginForm(actionData?: any) {

  clearLocalStorage();

  this?.authService?.updateAuthStatus(false);
  if(environment.tenant=='srichaitanya') 
  {
    openAdmissionLoginForm.call(this, {actionData});
  } else {
    openILLoginDialogComponent.call(this, {actionData});
  }
}

export function openAdmissionLoginForm(numberObj: any) {
  const config: MatDialogConfig = {
    width: '439px',
    panelClass: 'mat-full',
    data: {
      message: `${this.portal == 'SCORE' ? 'Phone Number' : 'Admission Number'} Login`,
      message2: `Please enter your registered ${this.portal == 'SCORE' ? 'phone number' : 'admission number'} and password to get started`,
      admissionNumber: numberObj.admissionNumber
    }
  };
  const dialogRef = this.dialog.open(AdmissionNumberLoginComponent, config);
}

export function openILLoginDialogComponent(numberObj: any) {
  
    const config: MatDialogConfig = {
      width: '439px',
      // height: '226px',
      data: { message: 'Hey, ready to get started?', actionData: numberObj?.actionData }
    };
    const dialogRef = this.dialog.open(LogindialogComponent, config);
}


export function registerNow(tests: Array<any>, examtype: any, showPop = true) {
  if(timeBoundTypes.indexOf(examtype) > -1) { 
    const key = examtype == "New NEET Timebound" ? "_new_pattern": "";
    const testType = this.tenant=='srichaitanya' ? ("SCTS"+key): ("ILTS"+key);
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    tests.forEach(test => {
      this.gaService.sendEvent(
        `${testType}_register_now`, 
        `${testType}_dashboard`, 
        `${testType}_register_now`,  
        `${test._id}`,  
        {
          'event': 'Infinity Learn Test Series (ILTS) Register',
          'Phone Number': user.phone,
          'First Name': user.firstName,
          'Last Name': user.lastName,
          'City': '',
          'Email ID': user.email,
          'Test Name': test.rulename,
          'User Id': user.userId,
          'Rank': test.rank,
          'Your Score': test.score,
        }
      );
    })
  }
  this.spinner.show();
  let body = {
    "rules": tests.map(test =>(
        {
          "ruleid": test._id,
          "span":test.span,
        })
      ),
      "studentid":localStorage.getItem('studentid'),
      phone: this.userService.getMobileAndName()?.phone,
    admissionNumber: this.tenant=='srichaitanya' ? localStorage.getItem('studentid'): '',
      "isActive":"true",
    "subscription": {
        "module": this.testListService?.getUSerExamlist?.packageKey,
        "id": this.testListService?.getUSerExamlist?.packageId
    }
  }
  let p = new Promise((rs, rj) => {
    
  this.scheduleService.registerExamSchedule(body).subscribe((data:any) => {
    //console.log(data);
    //{"id":"60a7957b8ffd4ec778b4db4f","message":"Exam registered for student successfully"}
    if(this.testRegistered) {
      this.testRegistered({tests, examtype});
    }
    this.spinner.hide();
    if(showPop) {
      let dialogRef = this.dialog.open(TestRegistrationConfirmDialogComponent, {
        height: '240px',
        width: '500px',
        data: {
          message1: 'Great!',
          message2: data.message,
        }
      });  
    }
    
    let testNameArray:any = [];
    let startTimeArray:any = [];
    let endTimeArray:any = [];
    tests.forEach((notEnrolledTest: any) => {
      let examstart = moment(notEnrolledTest.span, "YYYY-MM-DD hh:mm A").format("DD/MM/YYYY hh:mm A");
      let examendDateTime = moment(examstart,'DD/MM/YYYY hh:mm A').add(parseInt(notEnrolledTest.duration), 'minutes').format('DD/MM/YYYY hh:mm A');
      startTimeArray.push(examstart);
      endTimeArray.push(examendDateTime);
      testNameArray.push(notEnrolledTest.rulename)
    });
      
    let phoneAndName = this.userService.getMobileAndName();

    if (phoneAndName && phoneAndName.phone) {
      let body:any={
        "applicationLink": window.location.origin+'/',
        "liveDCLink": window.location.origin+'/',
        "name": phoneAndName.firstName+" "+phoneAndName.lastName,
        "phonenumber":phoneAndName.phone,
        "resultlink": window.location.origin+'/',
        "span": startTimeArray.join(),
        "testEndTime": endTimeArray.join(),
        "testName": testNameArray.join()
      }
      this.communicationMessageService.multiRegistrationMessage(body).subscribe(()=>{})
      rs(1);
    }
    
  }, err => {
    this.spinner.hide();
    console.log(err);
    rj(0);
  });
  });
return p;
}

export function successOpen(msg) {
  this.classService.syncStudent();
  const config: MatDialogConfig = {
    width: '487px',
    height: '292px',
    data: profileSuccess[msg]
  };
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, config);
  dialogRef.afterClosed().subscribe((value) => {
    if(window.location.pathname.indexOf('myprofile') !=-1){
      this.router.navigate([`/myprofile`]);
    }else{
      window.location.reload();
    }
  });
}